import React from "react";

interface Props {
  variant: "half" | "normal" | "double";
}

const MARGIN = {
  half: "10px",
  normal: "20px",
  double: "40px",
};

export const Spacer: React.FC<Props> = ({ variant }): JSX.Element => {
  return <div style={{ marginBottom: MARGIN[variant] }} />;
};
